import Vue from 'vue';
import { StatService } from '@pbx/services/StatService.js';
import { snakeStore } from '@app/plugins/vuex-async-pagginate';

export const table = snakeStore(
  {
    actions: {
      getData: (_, params) => {
        return StatService.getDetailed(params).catch(e => Vue.noty.server_error(e));
      }
    }
  },
  true
);
